import { SchemaExplorerFile } from './schemaExplorerFile';
import { SchemaExplorerFolder } from './schemaExplorerFolder';

interface SchemaExplorerNodeBaseProps {
  source: any;
  onFolderDelete: Function;
  onFolderToggle: Function;
}

export interface SchemaExplorerUIOptions {
  searchAreaBorder?: boolean;
  showFieldTypeIcon?: boolean;
  allowTableCreation?: boolean;
  showTableMenuOption?: boolean;
  showRelationsLineage?: boolean;
  reauthoriseWarningBody?: string;
}

export interface SchemaExplorerFileProps {
  file: SchemaExplorerFile;
  source: any;
  schemaExplorerUIOptions: SchemaExplorerUIOptions;
}

export interface SchemaExplorerFolderProps extends SchemaExplorerNodeBaseProps {
  folder: SchemaExplorerFolder;
  schemaExplorerUIOptions: SchemaExplorerUIOptions;
  dataId?: string;
}

export interface SchemaExplorerTreeProps extends SchemaExplorerNodeBaseProps {
  folders: SchemaExplorerFolder[];
  canShowViews?: boolean;
  schemaExplorerUIOptions: SchemaExplorerUIOptions;
}

export enum TreeNodeType {
  FILE,
  FOLDER
}
